import { cn } from '@brew/ui/cn'
import type { ReactNode } from 'react'
import { TYPE } from '@/lib/ui/typography'

/** One titled section of an integration page's tab: an h2 and its prose. */
export function ProseSection({
  title,
  children,
  id,
}: {
  title: string
  children: ReactNode
  /**
   * The heading's id, for a button or a finished action that moves focus
   * here: the heading then takes focus from script (never from Tab).
   */
  id?: string
}) {
  const isFocusTarget = id !== undefined
  return (
    <section className="flex flex-col gap-3">
      <h2
        className={cn(TYPE.heading, {
          'scroll-mt-6 rounded-sm outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50':
            isFocusTarget,
        })}
        id={id}
        tabIndex={isFocusTarget ? -1 : undefined}
      >
        {title}
      </h2>
      <div className={cn(TYPE.body, 'leading-relaxed')}>{children}</div>
    </section>
  )
}
